import React from 'react'
import { UseGlobelcourse } from './allcoursecontaxt/ALLCoursecontaxt';

function Filtercourse() {
    const {all_product} = UseGlobelcourse();
   

    const { filters:{ text , categoryname , instructor }, updatefiltervalue } = UseGlobelcourse();

        // Get unique categories from nested CourseMaster_courseCat.category_name

        const getUniqueCategories = (data) => {
  const categories = data
    .map(item => item.CourseMaster_courseCat?.category_name)
    .filter(Boolean); // filter out undefined/null
  return [...new Set(categories)];
};

// Get unique instructors from nested CourseMaster_Courseinstructor.CourseInstructor_name
const getUniqueInstructors = (data) => {
  const instructors = data
    .map(item => item.CourseMaster_Courseinstructor?.CourseInstructor_name)
    .filter(Boolean); // filter out undefined/null
  return [...new Set(instructors)];
};


    const categoryonlydata = getUniqueCategories(all_product);
    const  instructer = getUniqueInstructors(all_product);
 
    // const getpaiddata = (data , property)=>{
    //   let value = data.map((curElm)=>curElm[property]);
    //         return value;
    // }
      // const feesdata = getpaiddata(all_product , "CourseMaster_fee");
      
  return (
    <>
     <div className="col-xl-3 col-lg-4 order-lg-1" >
        <aside className="sidebar-area sidebar-shop">
          <div className="widget widget_search p-3 ">
            <form className="search-form p-1 " onSubmit={(e)=>e.preventDefault()}>
              <input 
              type="text"
              name='text'
               placeholder="Search Product..."
                value={text}
               onChange={updatefiltervalue}
                 />
              <button type="submit"><i className="far fa-search" /></button>
            </form>

          </div>

          <div className="widget widget_categories style2  ">
            <h3 className="widget_title">Categories</h3>

            
            <ul>
                <ul className="sub-cat" >
           {
            categoryonlydata.map((curelm , index )=>
                  <li key={index} style={{textTransform:"capitalize"}}>
                    <input 
                    id={`category-${index}`}
                    name="categoryname"
                    value={curelm}
                    type="checkbox" 
                    checked={categoryname.includes(curelm)} 
                    onChange={updatefiltervalue} />

                  <label  htmlFor={`category-${index}`}>{curelm}<span className="checkmark" /></label>
                   </li>
                )}
                </ul>
            </ul>
         </div>
         
          <div className="widget widget_price_filter style2  ">
            <h4 className="widget_title">Price Level</h4>
            <ul>
              <li><input 
              id="freecheck"
              name="price"
              value="free" 
              type="checkbox"
              onChange={updatefiltervalue} />

                <label htmlFor="freecheck">Free<span className="checkmark" /></label>
              </li>

              <li><input 
              id="paidcheck" 
              name="price"
              value="paid"
              type="checkbox"
              onChange={updatefiltervalue}    />
                <label htmlFor="paidcheck">Paid<span className="checkmark" /></label>
              </li>
            </ul>
          </div>


          {/* <div className="widget widget_time_duration style2  ">
            <h4 className="widget_title">Time Duration</h4>
            <ul>
              <li>
                <input id="timecheck1" name="timecheck1" type="checkbox" />

                <label htmlFor="timecheck1">6+hours (15)<span className="checkmark" /></label>
              </li>
              <li><input id="timecheck2" name="timecheck2" type="checkbox" />
                <label htmlFor="timecheck2">6+hours (15)<span className="checkmark" /></label>
              </li>
              <li><input id="timecheck3" name="timecheck3" type="checkbox" />
                <label htmlFor="timecheck3">6+hours (15)<span className="checkmark" /></label>
              </li>
            </ul>
          </div> */}



          <div className="widget widget_instructor style2  ">
            <h4 className="widget_title">Our Instructor</h4>

            <ul>
            {
                instructer.map((cutinst,index)=>(
              <li key={index}><input id= {`instructor ${index}`}
              name="instructor"
              type="checkbox" 
              value={cutinst}
              checked={instructor.includes(cutinst)} 
              onChange={updatefiltervalue}
              
              />
                <label htmlFor={`instructor ${index}`}>{cutinst}<span className="checkmark" /></label>
              </li>
                 ))
                 }


            </ul>

          </div>
        </aside>
   
      </div>
    </>
  )
}

export default Filtercourse
